/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Role_InvalidInputs */

const en_error_role_invalid = /** @type {(inputs: Error_Role_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The role cannot be saved as it is:`)
};

/**
* | output |
* | --- |
* | "The role cannot be saved as it is:" |
*
* @param {Error_Role_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_role_invalid = /** @type {((inputs?: Error_Role_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Role_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_role_invalid(inputs)
});